module.exports = {
  urlInfo:{
    queryUrl:'https://www.goodfoodchina.net'
  }
}
